import { LOCAL_STORAGE_USER } from "../constantsObservacions";

const authHeader = () => {
  // return authorization header with jwt token
  const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));

  if (user && user.token) {
    return { Authorization: "Bearer " + user.token };
  } else {
    return {};
  }
};

export default authHeader;
